<template>
  <!--
    `HelpBar` ist ein `v-navigation-drawer` mit `app` und braucht deshalb das
    `v-app`-Layout ueber sich. In `ReportBuilderCard` stand sie falsch: die
    Karte wird in Tests einzeln gemountet, und Vuetify meldete dort
    „Could not find injected layout". Die uebrigen Projektseiten halten die
    Schublade ebenfalls auf Ansichtsebene; der oeffnende Knopf sitzt in der
    Kartenleiste und kommt ueber den Store an sie heran.
  -->
  <HelpBar />
  <ReportBuilderCard :project-id="projectId" />
</template>

<script lang="ts" setup>
import { computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useProjectStore } from "@/stores/projectStore";
import ReportBuilderCard from "@/components/report/ReportBuilderCard.vue";
import HelpBar from "@/components/HelpBar.vue";

const route = useRoute();
const store = useProjectStore();
const projectId = computed(() => route.params.projectId);

onMounted(() => {
  if (projectId.value) {
    store.fetchCurrentProject(Number(projectId.value));
  }
});

watch(
  () => store.currentProject,
  (project) => {
    if (project) {
      // `name` ist am Projekttyp optional, `setTitle` nimmt `string | null` —
      // ohne den Rückfall stünde bei einem namenlosen Projekt `undefined` im
      // Seitentitel.
      store.setTitle(project.name ?? null);
    }
  },
  { immediate: true },
);
</script>
